import React from 'react';
import { FaMapMarkerAlt, FaClock, FaRuler, FaBus, FaWalking, FaCircle } from 'react-icons/fa';

function DetalhesRotaPlanner({ routeDetails, onBack, onStepClick }) {
  if (!routeDetails) {
    return null;
  }

  const { segments, summary } = routeDetails;

  return (
    <div className="sheet-detalhes-rota-planner-container">
      <button onClick={onBack} className="back-button">
        ← Voltar ao planejador
      </button>

      <div className="rota-planner-header">
        <h2><FaMapMarkerAlt /> Detalhes da Rota</h2>
        <p>{summary?.origin || 'Origem'} → {summary?.destination || 'Destino'}</p>
      </div>

      <div className="rota-info-summary">
        <div className="info-card">
          <span className="info-icon"><FaClock /></span>
          <div>
            <strong>{Math.ceil((summary?.duration || 0) / 60)} min</strong>
            <span>Duração</span>
          </div>
        </div>
        <div className="info-card">
          <span className="info-icon"><FaRuler /></span>
          <div>
            <strong>{((summary?.distance || 0) / 1000).toFixed(1)} km</strong>
            <span>Distância</span>
          </div>
        </div>
        <div className="info-card">
          <span className="info-icon"><FaBus /></span>
          <div>
            <strong>{segments?.filter(s => s.mode !== 'WALK').length || 0}</strong>
            <span>Ônibus</span>
          </div>
        </div>
      </div>

      {segments && segments.length > 0 && (
        <div className="passos-lista">
          <h3 className="section-title">
            Passo a Passo
          </h3>
          <div className="passos-sequencia">
            {segments.map((segment, index) => {
              const isWalk = segment.mode === 'WALK';
              const icon = isWalk ? <FaWalking /> : <FaBus />;
              const color = isWalk ? '#ef4444' : (segment.routeColor ? `#${segment.routeColor}` : '#10b981');
              
              return (
                <div key={index} className="passo-card">
                  <div className="passo-timeline">
                    <div 
                      className="passo-icon" 
                      style={{ backgroundColor: color }}
                    >
                      {icon}
                    </div>
                    {index < segments.length - 1 && <div className="passo-line"></div>}
                  </div>
                  
                  <div className="passo-content">
                    <div className="passo-header">
                      {isWalk ? (
                        <strong>Caminhe {Math.ceil(segment.distance / 100) * 100}m</strong>
                      ) : (
                        <div className="passo-bus-info">
                          <div className="bus-badge" style={{ backgroundColor: color }}>
                            {segment.routeShortName || 'Ônibus'}
                          </div>
                          <strong>{segment.routeLongName || 'Linha de ônibus'}</strong>
                        </div>
                      )}
                    </div>

                    {!isWalk && segment.tripHeadsign && (
                      <p className="passo-direction">
                        Sentido: {segment.tripHeadsign}
                      </p>
                    )}

                    <div className="passo-pontos">
                      {segment.from && (
                        <div 
                          className="ponto-item origem"
                          onClick={() => {
                            const lat = segment.fromCoordinates?.[0];
                            const lon = segment.fromCoordinates?.[1];
                            if (lat && lon) {
                              onStepClick(lat, lon, segment.from);
                            }
                          }}
                        >
                          <span className="ponto-marker"><FaCircle style={{color: '#10b981'}} /></span>
                          <span className="ponto-nome">{segment.from}</span>
                          <span className="ponto-action"><FaMapMarkerAlt /></span>
                        </div>
                      )}

                      {!isWalk && segment.intermediateStops && segment.intermediateStops.length > 0 && (
                        <div className="intermediate-stops-summary">
                          <span>↓ {segment.intermediateStops.length} parada{segment.intermediateStops.length > 1 ? 's' : ''} intermediária{segment.intermediateStops.length > 1 ? 's' : ''}</span>
                        </div>
                      )}

                      {segment.to && (
                        <div 
                          className="ponto-item destino"
                          onClick={() => {
                            const lat = segment.toCoordinates?.[0];
                            const lon = segment.toCoordinates?.[1];
                            if (lat && lon) {
                              onStepClick(lat, lon, segment.to);
                            }
                          }}
                        >
                          <span className="ponto-marker"><FaCircle style={{color: '#ef4444'}} /></span>
                          <span className="ponto-nome">{segment.to}</span>
                          <span className="ponto-action"><FaMapMarkerAlt /></span>
                        </div>
                      )}
                    </div>

                    <div className="passo-meta">
                      <span><FaClock /> {Math.ceil((segment.duration || 0) / 60)} min</span>
                      <span><FaRuler /> {((segment.distance || 0) / 1000).toFixed(2)} km</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default DetalhesRotaPlanner;
